<template>
  <div class="sort-by">
    <select
      id="sort-by"
      name="sortby"
      class="cl-light-gray h5 brdr-1 brdr-cl-secondary-gray secondary-font"
      v-model="sortby"
      @change="changeOrder"
    >
      <option v-for="variant in sortingVariants" :value="variant" :key="variant.id">
        {{ $t('Sort by') }}: {{ $t(variant.label) }}
      </option>
    </select>
    <label for="sort-by" class="visually-hidden">{{ $t('Sort by') }}</label>
  </div>
</template>

<script>
import SortBy from '@vue-storefront/core/compatibility/components/SortBy'
import { products } from 'config'
export default {
  mixins: [SortBy],
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      sortby: null
    }
  },
  watch: {
    value: {
      handler () {
        const defaultVariant = this.value && this.value.length ? this.value : products.defaultSortBy.attribute
        this.sortby = this.sortingVariants.find(variant => variant.id.includes(defaultVariant))
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
    @import '~theme/css/base/text';
    @import '~theme/css/variables/colors';
    @import '~theme/css/helpers/functions/color';
    $color-tertiary: color(tertiary);
    .sort-by {
        display: inline-flex;
        position: relative;
        select {
            @media (max-width: 990px) {
              max-width: initial;
            }
            max-width: 260px;
            font-size: 14px;
            width: 100%;
            border-radius: 0;
            background-color: transparent;
            margin-right: 0;
            padding: 3px;
            &:focus {
                outline: none;
            }
        }
    }
    @media (max-width: 770px) {
      .sort-by {
        width: 100%;
      }
    }
</style>
